import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import WithWindowSize from 'Components/WithWindowSize'
import BookViewingBox from 'Components/BookViewingBox'


const FloatingBox = ({
  handleOfferClick, handleBookViewing, handleContactAgentClick, ctaSource, agent, googleAnalyticsEvent,
  userAgentId,
  isArchived, listing, winWidth, userIsAuthentificated,
  withOfferCta, handleSellBtnClick, isPrecon,
}) => {
  const [isDesktop, setDesktop] = useState(false)

  useEffect(() => {
    if((!isDesktop && winWidth > 1024) || (isDesktop && winWidth <= 1024)) setDesktop(!isDesktop)
  }, [isDesktop, winWidth])

  const onPhoneClick = () => {
    googleAnalyticsEvent({
      category: isPrecon ? 'precon listing' : 'listing',

      action: '[Agent Phone Click]',
    })
  }
  const onOfferClick = () => {
    handleOfferClick(ctaSource, agent)
  }
  const onBookViewing = () => {
    handleBookViewing(ctaSource, agent)
  }
  const onContactAgentClick = () => {
    handleContactAgentClick(ctaSource, agent)
  }

  if(listing && isDesktop && agent) {
    return (
      <BookViewingBox
        handleSellBtnClick={handleSellBtnClick}
        onBookClick={onBookViewing}
        onOfferClick={onOfferClick}
        handleContactAgentClick={onContactAgentClick}
        userAgentId={userAgentId}
        myAgent={agent}
        listing={listing}
        phoneClick={onPhoneClick}
        userIsAuthentificated={userIsAuthentificated}
        withOfferCta={withOfferCta}
        isArchived={isArchived}
        onProfileLinkClick={(source) => {
          googleAnalyticsEvent({
            category: 'listing',
            action: ['Agent Profile Click', 'Booking Card', source],
          })
        }}
        isPrecon={isPrecon}
      />
    )
  }
  return null
}

FloatingBox.propTypes = {
  listing: PropTypes.shape({
    agents: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.number,
    title: PropTypes.string,
    asking_price: PropTypes.number,
  }),
  isArchived: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
  handleContactAgentClick: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  userAgentId: PropTypes.number,
  winWidth: PropTypes.number,
  agent: PropTypes.shape({
    id: PropTypes.number,
    fullname: PropTypes.string,
    profile_image: PropTypes.shape({}),
    url: PropTypes.string,
    title: PropTypes.string,
    brokerage_name: PropTypes.string,
    email: PropTypes.string,
    cell: PropTypes.string,
  }),
  handleBookViewing: PropTypes.func,
  handleOfferClick: PropTypes.func,
  withOfferCta: PropTypes.bool,
  ctaSource: PropTypes.string,
  handleSellBtnClick: PropTypes.func,
  isPrecon: PropTypes.bool,
}

export default WithWindowSize(FloatingBox)
